import React from 'react'
import ReactDOM from 'react-dom'
import App from './index'

/*
{
  function inject(src, onload) {
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.onload = onload
    script.src = src
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  inject('https://s3-sa-east-1.amazonaws.com/aquiperto.app/build-standalone/gofind-standalone.js', console.log)
}
 */

// function injectScript(src) {
//   return new Promise((resolve) => {
//     const script = document.createElement('script')
//     script.type = 'text/javascript'
//     script.onload = resolve
//     script.src = src
//     document.getElementsByTagName('head')[0].appendChild(script)
//   })
// }

//const googleUrl = 'https://api.mapbox.com/mapbox-gl-js/v2.11.0/mapbox-gl.js'
//  'https://maps.google.com/maps/api/js?libraries=places&key=AIzaSyBgQEPPBhJGNi0eDyhNyS-YHLyIucdzFPM'

//const maps = injectScript(googleUrl)

window.gofind = async (element, domain, options = {}) => {
  if (domain) ReactDOM.render(<App standalone domain={domain} />, element)
  else ReactDOM.render(<App />, element)
  return () => {} // unmount fn
}
